module.exports = __webpack_public_path__ + "8b3408a16290a91bd01a234e15d93b6a.png";